import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import Loader from "../../shared/loader";
const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: '31px',
    height: '31px',
  }),
  valueContainer: (base) => ({
    ...base,
    height: '31px',
    padding: '.25rem .5rem',
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '31px',
  }),
};

const Product = () => {
  const [productData, setProductData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sizeDrp, setSizeDrpData] = useState([]);
  const [formData, setFormData] = useState({
    size_id: "",
  });
  
  const getProduct = () => {
    setLoading(true);
    axios
      .post(API_URL.PRODUCT_LIST, {
        size_id: formData.size_id,
      })
      .then(
        (res) => {
          if (res.data.status === 1) {
            setProductData(res.data.data.data);
          }
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          toast.error("Something went wrong..", {
            autoClose: 3000,
            position: "top-right",
          });
        }
      );
  };

  const getSizeDrpData = () => {
    axios.post(API_URL.SIZE_LIST, {}).then((res) => {
      setSizeDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setSizeDrpData(cd);
    });
  };

  const deletProduct = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PRODUCT_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = productData.filter((r) => r.id != row.id);
              setProductData(newData);
            }
            toast.success(row.name + " Delete Successfully", {
              autoClose: 3000,
              position: "top-right",
            });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-right",
            });
          }
        );
      }
    });
  };

  useEffect(() => {
    getProduct();
    getSizeDrpData();
  }, []);

  useEffect(() => {
    getProduct();
  }, [formData.size_id]);

  return (
    <>
      <div className="page-header">
        <div className="d-flex align-items-center content-page-header">
          <div className="d-flex align-items-center">
            <h5 className="me-1">Product</h5>
            <small className="me-2">({productData.length})</small>
            <div className="form-group mb-0" style={{ width: "250px" }}>
              <Select
                placeholder="Select Size"
                styles={customStyles}
                options={sizeDrp}
                isClearable={true}
                value={sizeDrp.find((r) => r.value == formData.size_id)}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    size_id: e?.value ? e.value : null,
                  });
                }}
              />
            </div>
          </div>
          <div>
            <div className="list-btn">
              <ul className="filter-list">
                <li>
                  <Link
                    to={"/admin/product/add"}
                    className="btn btn-primary btn-sm"
                  >
                    <i
                      className="fa fa-plus-circle me-2"
                      aria-hidden="true"
                    ></i>
                    Product
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: "5%" }}>#</th>
                        <th style={{ width: "10%" }}>Image</th>
                        <th style={{ width: "25%" }}>Name</th>
                        <th style={{ width: "25%" }}>Size</th>
                        <th style={{ width: "25%" }}>Series</th>
                        <th style={{ width: "10%" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {productData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td className="table-avatar">
                              <div
                                style={{
                                  backgroundImage: "url(" + row.image + ")",
                                  backgroundSize: 'cover',
                                  height: 50,
                                  width: 50
                                }}
                              ></div>
                            </td>
                            <td>
                              {row.name}
                            </td>
                            <td>
                              {row.size_name}
                            </td>
                            <td>
                              {row.series_name}
                            </td>
                            <td className="d-flex justify-content-end gap-3">
                              <Link to={"/admin/product/edit/" + row.id}>
                                <i className="fa fa-edit"></i>
                              </Link>
                                <i onClick={() => deletProduct(row)} className="fa fa-trash-alt"></i>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
